import {
  CONTACT_ALL, CONTACT_GET, CONTACT_PUT, CONTACT_DEL, CONTACT_POST,
  CONTACT_RESET, CONTACT_LOADING, CONTACT_ERROR,
} from '../../actions/types';

const initialState = {
  contact: null,
  isLoading: true,
  isCompleted: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CONTACT_ALL:
    case CONTACT_GET:
      return { ...action.payload, isLoading: false, isCompleted: true };
    case CONTACT_POST:
    case CONTACT_PUT:
    case CONTACT_DEL:
      return { isLoading: false, isCompleted: true };
    case CONTACT_RESET:
      return { contact: null, isLoading: true, isCompleted: true };
    case CONTACT_LOADING:
      return { isLoading: true, isCompleted: true };
    case CONTACT_ERROR:
      return { isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
